import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    DatiqAnalyticsInputInteraction,
    IDatiqAnalyticsEvent,
    IDatiqAnalyticsEventInputInfo,
} from '@dat/datiq-core/models';

import { DatiqFileDownloadActions } from '../../../store';
import { IDatiqDownload } from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqFileDownloadMapperService {
    constructor(private _sanitizer: DomSanitizer) {}

    mapFileDownloadEvent({
        props,
        id,
    }: Partial<IDatiqDownload>): IDatiqAnalyticsEvent {
        const eventName: string = this.mapFileDownloadEventName();
        const inputInfo: IDatiqAnalyticsEventInputInfo =
            this.mapFileDownloadEventInfo(props, id);

        return {
            eventName,
            inputInfo,
        };
    }
    mapFileDownloadEventName(): string {
        return DatiqFileDownloadActions.createNewDownloadName;
    }
    mapFileDownloadEventInfo(
        props: unknown,
        id: string
    ): IDatiqAnalyticsEventInputInfo {
        const inputId: string = this.mapFileDownloadEventInfoId(id);
        const interaction: DatiqAnalyticsInputInteraction =
            this.mapFileDownloadEventInfoInteraction();
        return {
            inputId,
            interaction,
            props,
        };
    }
    mapFileDownloadEventInfoInteraction(): DatiqAnalyticsInputInteraction {
        return DatiqAnalyticsInputInteraction.Click;
    }
    mapFileDownloadEventInfoId(id: string): string {
        return id;
    }
}
